// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"51":"0eb8cf6e","199":"0bc2deb1","254":"10bc864a","410":"63cb99d9","448":"a4e6cb32","519":"1e40856b","648":"1ae3f77e","743":"8b466bb7","977":"0f4f9601"}[chunkId] + ".js";
};